import { Component, inject, input, output, signal } from '@angular/core';
import {
  SimpleDialogLayout,
  Button,
  InputLabel,
  InputSimple,
  Select,
  InputError,
} from 'excellence-ui';
import { OrganizationMember } from '../../../../core/clients/omni-core/models';
import { email, form, FormField, required } from '@angular/forms/signals';
import { FieldErrors } from '../../../../shared/components/field-errors/field-errors';
import { Api } from '../../../../core/clients/omni-core/api';
import { createOrgInvite } from '../../../../core/clients/omni-core/functions';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganizationRolePipe } from '../../../organizations/pipes/organization-role-pipe';

@Component({
  selector: 'app-settings-orga-invite-create-dialog',
  imports: [
    SimpleDialogLayout,
    Button,
    InputLabel,
    InputSimple,
    Select,
    FormField,
    FieldErrors,
    InputError,
    TranslocoPipe,
    OrganizationRolePipe,
  ],
  templateUrl: './settings-orga-invite-create-dialog.html',
})
export class SettingsOrgaInviteCreateDialog {
  private api = inject(Api);

  organizationId = input.required<string>();
  clickCancel = output();
  createSuccess = output();

  private data = signal<{ email: string; role: OrganizationMember['roleId'] }>({
    email: '',
    role: 'ORGANIZATION_MEMBER',
  });

  protected form = form(this.data, (schemaPath) => {
    required(schemaPath.email);
    email(schemaPath.email);
    required(schemaPath.role);
  });

  protected showValidationErrors = signal(false);
  protected isCreateLoading = signal(false);
  protected createError = signal<unknown | null>(null);

  protected async onSubmit() {
    if (this.form().invalid()) {
      this.showValidationErrors.set(true);
      this.form.email().markAsTouched();
      this.form.role().markAsTouched();
      return;
    }
    const data = this.data();
    this.isCreateLoading.set(true);
    this.createError.set(null);
    try {
      await this.api.invoke(createOrgInvite, {
        id: this.organizationId(),
        body: {
          toEmail: data.email.trim(),
          roleId: data.role,
        },
      });
      this.clear();
      this.isCreateLoading.set(false);
      this.createSuccess.emit();
    } catch (error) {
      console.error('Error creating organization invite:', error);
      this.isCreateLoading.set(false);
      this.createError.set(error);
      throw error;
    }
  }

  private clear() {
    this.form().reset();
    this.showValidationErrors.set(false);
    this.data.set({ email: '', role: 'ORGANIZATION_MEMBER' });
  }
}
